import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';
import { LocaleContext } from '../../Banner';

const getStepContent = (step, key) => {
  if (typeof step === 'string')
    return (
      <span
        className={cn(styles.text)}
        data-testid={`step-heading-${key}`}
        dangerouslySetInnerHTML={{ __html: step }}
      />
    );

  return (
    <>
      <span className={cn(styles.text, styles.heading)} data-testid={`step-heading-${key}`}>
        {step?.heading}
      </span>
      <span
        className={cn(styles.text)}
        data-testid={`step-description-${key}`}
        dangerouslySetInnerHTML={{ __html: step.description }}
      />
    </>
  );
};

const Step = ({ step, keyValue, stepClick }) => {
  const { dataJurisdiction } = useContext(LocaleContext);

  return (
    <div
      className={cn(styles.bannersTab)}
      data-jurisdiction={dataJurisdiction}
      data-testid={`banner-${keyValue}`}
      key={typeof step === 'string' ? step : step?.heading}
      onClick={() => stepClick()}
      role="presentation"
    >
      <div className={cn(styles.bannerTextContainer)} data-testid={`banner-text-${keyValue}`}>
        {getStepContent(step, keyValue)}
      </div>
    </div>
  );
};

Step.propTypes = {
  step: PropTypes.oneOfType([
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string,
      headline: PropTypes.shape({}),
      select_action: PropTypes.string,
    }),
    PropTypes.string,
  ]).isRequired,
  keyValue: PropTypes.number.isRequired,
  stepClick: PropTypes.func.isRequired,
};

export default Step;
